"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _user = require("@/api/admin/user/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      options: [{
        name: "查看管理员",
        class: "edit",
        option: "viewAdmin",
        span: 3
      }],
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称"
      }
      // {
      //   label: "是否禁用",
      //   type: "select",
      //   model: "isStop",
      //   placeholder: "",
      //   options: [
      //     { label: 1, value: "是" },
      //     { label: 2, value: "否" },
      //   ],
      // },
      ],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "编码",
        prop: "uniqueCode",
        isShow: true,
        width: "100"
      }, {
        name: "省份",
        prop: "name",
        isShow: true,
        width: "150"
      }, {
        name: "状态",
        prop: "isLock",
        isShow: true,
        width: "150"
      }, {
        name: "开始日期",
        prop: "startTime",
        isShow: true,
        width: "150"
      }, {
        name: "截止日期",
        prop: "endTime",
        isShow: true,
        width: "150"
      }, {
        name: "创建日期",
        prop: "creatTime",
        isShow: true,
        width: "100",
        isFormats: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      name: "",
      checkBoxs: []
    };
  },
  methods: {
    // 查看管理员
    viewAdmin: function viewAdmin(e) {
      this.$router.push({
        path: "/province/provinceAdminList",
        query: {
          title: e.name,
          id: e.id
        }
      });
    },
    // 搜索框
    search: function search(v) {
      console.log(v);
      this.name = v.queryValue;
      this.getProvinceList();
    },
    // 编辑按钮操作
    editBureau: function editBureau(row) {
      console.log(row);
      this.$router.push({
        path: "/province/provinceList-edit",
        query: row
      });
    },
    // 新增按钮操作
    add: function add() {
      this.$router.push("/province/provinceList-add");
    },
    // 设置管理员
    setSys: function setSys() {
      this.$router.push("/province/provinceList-setSys");
    },
    handleSelectionChange: function handleSelectionChange(row) {
      var _this = this;
      this.checkBoxs = [];
      row.forEach(function (item) {
        _this.checkBoxs.push(item.id);
      });
    },
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getProvinceList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getProvinceList();
    },
    // 获取省份列表
    getProvinceList: function getProvinceList() {
      var _this2 = this;
      (0, _user.getProvince)({
        name: this.name,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        uniqueCode: ""
      }).then(function (res) {
        var data = res.data;
        _this2.totalData = data.total;
        _this2.listData = data.list;
      }).catch(function (e) {
        return e;
      });
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getProvinceList();
  }
};